// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#mark {\r\n  width: 32px;\r\n  margin-right: 10px;\n}\np {\r\n  line-height: 1.5;\n}\r\n", ""]);
// Exports
module.exports = exports;
